import { Controller } from "@hotwired/stimulus"
import { getItem } from "../utils/local_storage"

export default class extends Controller {
  static targets = ["episode", "summary", "bar"]
  static values = { site: String }

  connect() {
    this.refresh()
    this.storageListener = () => this.refresh()
    window.addEventListener("storage", this.storageListener)
  }

  disconnect() { window.removeEventListener("storage", this.storageListener) }

  refresh() {
    const videos = this.episodeTargets.filter(row => row.dataset.recordId)
    let complete = 0
    videos.forEach(row => {
      const state = getItem(`devgab:signal:${this.siteValue}:video:${row.dataset.recordId}`, {})
      const done = state?.complete === true
      row.classList.toggle("is-complete", done)
      if (done) complete++
    })
    if (this.hasSummaryTarget && videos.length) this.summaryTarget.textContent = `${complete} of ${videos.length} available videos completed`
    if (this.hasBarTarget) this.barTarget.style.width = `${videos.length ? complete / videos.length * 100 : 0}%`
  }
}
